import axios from 'axios';
import Cookies from 'universal-cookie';
import config from '../../../config';

const cookies = new Cookies();
const BASE_URL = config.API_BASE_URL;

const getAuthHeaders = () => {
  const token = cookies.get('TOKEN');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getOtrosById = (id) =>
  axios.get(`${BASE_URL}/otros/${id}`, { headers: getAuthHeaders() }).then((r) => r.data);

export const updateOtros = (id, payload) =>
  axios.put(`${BASE_URL}/otros/${id}`, payload, { headers: getAuthHeaders() }).then((r) => r.data);

export const deleteOtros = (id) =>
  axios.delete(`${BASE_URL}/otros/${id}`, { headers: getAuthHeaders() }).then((r) => r.data);

export const getPacienteInformeById = (pacienteId) =>
  axios.get(`${BASE_URL}/pacientes/informes/${pacienteId}`, { headers: getAuthHeaders() }).then((r) => r.data);

export const getAllInformes = () =>
  axios.get(`${BASE_URL}/informes`, { headers: getAuthHeaders() }).then((r) => r.data);

export const getUserById = (userId) =>
  axios.get(`${BASE_URL}/users/${userId}`, { headers: getAuthHeaders() }).then((r) => r.data);

export const getPacienteByCodigo = (codigo) =>
  axios.get(`${BASE_URL}/pacientes/${codigo}`, { headers: getAuthHeaders() }).then((r) => r.data);

export const createOtros = (pacienteId, userId, payload) =>
  axios.post(`${BASE_URL}/otros/${pacienteId}/${userId}`, payload, { headers: getAuthHeaders() }).then((r) => r.data);
